import store from "@/store";
import { isLoggedIn } from "axios-jwt";

export const errorHandler = (err) => {
  // Ignore the vuex err regarding  navigating to the page they are already on.
  if (
    err.name !== "NavigationDuplicated" &&
    !err.message.includes("Avoided redundant navigation to current location")
  ) {
    // But print any other errors to the console
    if (window && window.console) {
      console.error(err);
    }
  }
};

export const ifAnonymous = async (to, from, next) => {
  if (!isLoggedIn()) {
    return next();
  }

  return next("/");
};

export const ifAuthenticated = async (to, from, next) => {
  if (!isLoggedIn()) {
    if (from.path === "/register") {
      return next("/register");
    }
    return next("/login");
  }

  try {
    await store.dispatch("auth/refresh");
    next();
  } catch (e) {
    if (from.path === "/register") {
      return next("/register");
    }
    return next("/login");
  }
};

export const ifAdmin = async (to, from, next) => {
  if (!isLoggedIn()) {
    return next("/login");
  }

  try {
    await store.dispatch("auth/refresh");

    if (store.state.auth.user.scopes === "admin") {
      next();
    } else {
      next("/forbidden");
    }
  } catch (e) {
    next("/login");
  }
};

export const ifFullyRegistered = async (to, from, next) => {
  if (!isLoggedIn()) {
    return next("/login");
  }

  try {
    await store.dispatch("auth/refresh");

    if (store.state.auth.user.scopes) {
      next();
    } else {
      next("/forbidden");
    }
  } catch (e) {
    next("/login");
  }
};
